module.exports = __webpack_public_path__ + "static/media/banner-PGL01.38e0c55f.jpg";